module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-vehicle-replace-action-buttons"
  }, [_c('div', {
    staticClass: "button-group small text-center"
  }, [_c('button', {
    staticClass: "button small",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('cancelAndBook', _vm.item)
      }
    }
  }, [_vm._v("Cancel & Book")]), _c('button', {
    staticClass: "button small",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('voidAndBook', _vm.item)
      }
    }
  }, [_vm._v("Void & Book")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0b1231cd!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/actions/VehicleReplaceButtons.vue
// module id = 2252
// module chunks = 1